<script>
import ServerTable from "../elements/ServerTable";

export default {
	components: {
		ServerTable,
	}
};
</script>

<template>
	<server-table/>
</template>


// WEBPACK FOOTER //
// src/components/views/Status.vue